export const currentAccount = {
    currentAccountTicketingService: { enabled: true },
    freeCashWithdrawal: { enabled: false },
    secondaryIdManagement: {
        enabled: false,
    },
    requestToPay: { enabled: false },
    roundupSavings: { enabled: false },
    currentAccountOverdraftSetup: { enabled: false },
    currentAccountOverdraftChange: { enabled: false },
    moneyAside: { enabled: false },
    currentAccountArchive: { enabled: false },
    currentAccountInsurance: { enabled: false },
    currentAccount: { associatedCards: { enabled: true } },
};
